import styled from 'styled-components'
import { Link } from 'react-router-dom'

const BackLink = styled(Link)`
  display: block;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 40px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.brand.jungle};
`

export const BackLinkAnchor = styled.a`
  display: block;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 40px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.brand.jungle};
`

export default BackLink
